import { Moment } from 'moment';

export enum InstallmentsNFSEPaymentType {
  CASH = 'CASH',
  PRESENTATION = 'PRESENTATION',
  DEADLINE = 'DEADLINE',
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}

export const parseNfsInstallmentsPayamentType = {
  [InstallmentsNFSEPaymentType.CASH]: 'Dinheiro',
  [InstallmentsNFSEPaymentType.PRESENTATION]: 'Apresentação',
  [InstallmentsNFSEPaymentType.DEADLINE]: 'Prazo',
  [InstallmentsNFSEPaymentType.DEBIT]: 'Débito',
  [InstallmentsNFSEPaymentType.CREDIT]: 'Crédito',
};

export interface NfsInstallments {
  dueDate: string;
  number: number;
  paymentType: InstallmentsNFSEPaymentType;
  value: number;
  id: number;
}

export interface InstallmentEditRequest {
  invoiceId: number;
  id: number;
}

export interface CreateNfsInstallment {
  dueDate: string;
  number: number;
  paymentType: InstallmentsNFSEPaymentType;
  value: number;
  invoiceId: number;
}

export interface UpdateNfsInstallment {
  dueDate: string;
  number: number;
  paymentType: InstallmentsNFSEPaymentType;
  value: number;
  invoiceId: number;
  id: number;
}

export interface NfsInstallmentFormValues {
  dueDate: Moment;
  number: number;
  paymentType: InstallmentsNFSEPaymentType;
  value: number;
}
